import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader, type GLTF } from 'three/addons/loaders/GLTFLoader.js';
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';
import lineup from '../art/character-lineup.json';
type Manifest = {
    revision: string;
    detailCameras?: Record<string, {target: number[]; offset: number[]}>;
    lods: {
        lod: number;
        triangles: number;
        bytes: number;
        url: string;
    }[];
    clips: string[];
};
const $ = <T extends HTMLElement>(selector: string) => document.querySelector<T>(selector)!;
const parameters = new URLSearchParams(location.search);
const characterInfo = lineup.characters.find(c => c.id === parameters.get('character'));
const character = characterInfo?.id || 'default';
const revision = characterInfo ? 'v01' : ['r01','r02','r03'].includes(parameters.get('revision') || '') ? parameters.get('revision')! : 'r04';
const assetPrefix = characterInfo ? `${character}-v01` : `hero-${revision}`;
const requestedPose = parameters.get('pose') || (characterInfo ? 'Stand' : 'Neutral');
const initialPose = [...['Neutral','Reach','Hang','Flight','TailHang','Idle','Swing'], ...(characterInfo ? ['Stand'] : [])].includes(requestedPose) ? requestedPose : 'Neutral';
const requestedCamera = parameters.get('view') || 'portrait';
const initialCamera = ['portrait','front','side','back','face','hands','feet','belly','shoulders'].includes(requestedCamera) ? requestedCamera : 'portrait';
$<HTMLSelectElement>('#revision-select').value = revision;
$<HTMLSelectElement>('#character-select').value = character;
$('#revision-select').closest<HTMLElement>('.detail-row')!.hidden = !!characterInfo;
$('[data-pose="Stand"]').hidden = !characterInfo;
$('[data-pose="Neutral"]').hidden = !!characterInfo;
$('.revision').innerHTML = `01 <span>/</span> ${characterInfo?.name.toUpperCase() || 'HERO MONKEY'} <span>·</span> ${revision.toUpperCase()}`;
$('.version').textContent = `${revision.toUpperCase()} / REVIEW`;
$<HTMLAnchorElement>('.export').href = `/assets/${assetPrefix}-lod0.glb`;
if (characterInfo) {
    $('.panel-heading h2').textContent = `${characterInfo.name}, in focus.`;
    $('.panel-heading .eyebrow').textContent = 'THE STANDING LINEUP';
    $('.specimen strong').textContent = `${characterInfo.name} spider monkey`;
    $('.specimen em').textContent = characterInfo.description;
    $('.intro-copy').textContent = `${characterInfo.name}, one of the troop. Long limbs. Curious eyes. A character all their own.`;
}
const mount = $('#viewport');
const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false, preserveDrawingBuffer: true });
renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.12;
renderer.outputColorSpace = THREE.SRGBColorSpace;
mount.appendChild(renderer.domElement);
renderer.domElement.setAttribute('aria-label', 'Interactive 3D spider monkey');
renderer.domElement.setAttribute('role', 'img');
const scene = new THREE.Scene();
scene.background = new THREE.Color('#e8e5d7');
scene.fog = new THREE.Fog('#e8e5d7', 12, 27);
const camera = new THREE.PerspectiveCamera(31, 1, .05, 60);
const controls = new OrbitControls(camera, renderer.domElement);
controls.enableDamping = true;
controls.dampingFactor = .08;
controls.minDistance = .4;
controls.maxDistance = 12;
controls.maxPolarAngle = Math.PI * .83;
controls.autoRotateSpeed = .65;
controls.enablePan = true;
const pmrem = new THREE.PMREMGenerator(renderer);
const room = new RoomEnvironment();
const env = pmrem.fromScene(room, .04);
scene.environment = env.texture;
scene.environmentIntensity = .36;
room.dispose();
pmrem.dispose();
const hemi = new THREE.HemisphereLight('#dae9f2', '#746249', 1.0);
scene.add(hemi);
const sun = new THREE.DirectionalLight('#fff2d9', 2.25);
sun.position.set(-3, 5, 4);
sun.castShadow = true;
sun.shadow.mapSize.set(2048, 2048);
sun.shadow.camera.left = -3;
sun.shadow.camera.right = 3;
sun.shadow.camera.top = 4;
sun.shadow.camera.bottom = -2;
sun.shadow.camera.near = .1;
sun.shadow.camera.far = 15;
sun.shadow.normalBias = .025;
sun.shadow.bias = -.0001;
sun.shadow.radius = 3;
scene.add(sun);
sun.target.position.set(0, 1, 0);
scene.add(sun.target);
const fill = new THREE.DirectionalLight('#d4e2ff', 1.1);
fill.position.set(4, 2, 3);
scene.add(fill);
const rim = new THREE.DirectionalLight('#ffcf87', 2.0);
rim.position.set(1, 3, -3);
scene.add(rim);
const floor = new THREE.Mesh(new THREE.PlaneGeometry(200, 200), new THREE.MeshStandardMaterial({ color: '#dcdccb', roughness: .95 }));
floor.rotation.x = -Math.PI / 2;
floor.position.y = .011;
floor.receiveShadow = true;
scene.add(floor);
// A quiet oval plinth establishes contact without distracting from the specimen.
const plinth = new THREE.Mesh(new THREE.CylinderGeometry(.79, .82, .025, 96), new THREE.MeshStandardMaterial({ color: '#d2d5bf', roughness: .92 }));
plinth.position.set(.17, .006, 0);
plinth.scale.z = .66;
plinth.receiveShadow = true;
scene.add(plinth);
// A small grip reference makes hanging poses readable during art review.
const gripCurve = new THREE.CatmullRomCurve3([new THREE.Vector3(-.48, -.015, 0), new THREE.Vector3(-.2, .012, 0), new THREE.Vector3(.2, 0, 0), new THREE.Vector3(.48, .045, .025)]);
const gripBranch = new THREE.Mesh(new THREE.TubeGeometry(gripCurve, 18, .027, 10, false), new THREE.MeshStandardMaterial({ color: '#786043', roughness: .95 }));
gripBranch.scale.setScalar(characterInfo?.height || 1);
gripBranch.visible = false;
gripBranch.castShadow = true;
scene.add(gripBranch);
function updateGrip() { const hanging = state.pose === 'Hang' || state.pose === 'Swing' || state.pose === 'TailHang'; gripBranch.visible = hanging && !!model; if (!hanging || !model)
    return; model.updateMatrixWorld(true); const bone = model.getObjectByName(THREE.PropertyBinding.sanitizeNodeName(state.pose === 'TailHang' ? 'tail.15' : 'attach.hand.L')); if (!bone)
    return; bone.getWorldPosition(gripBranch.position); if (state.pose === 'TailHang') {
    gripBranch.rotation.set(0, 0, .05);
    gripBranch.position.y += .015;
}
else {
    bone.getWorldQuaternion(gripBranch.quaternion);
    gripBranch.position.z += .015;
} }
const state = { character, revision, pose: initialPose, expression: 'Delight', strength: .5, playing: false, lod: 0, light: 'studio', camera: initialCamera, wireframe: false, ready: false };
let model: THREE.Group | undefined;
let mixer: THREE.AnimationMixer | undefined;
let currentAction: THREE.AnimationAction | undefined;
let animations: THREE.AnimationClip[] = [];
let manifest: Manifest;
let loadVersion = 0;
let clipTime = 0;
let frameCount = 0;
let fpsTime = 0;
let previousTime = performance.now();
let fps = 0;
const loader = new GLTFLoader();
const cache = new Map<number, GLTF>();
function setActive(selector: string, key: string, value: string) { document.querySelectorAll<HTMLButtonElement>(selector).forEach(b => { const active = b.dataset[key] === value; b.classList.toggle('active', active); b.setAttribute('aria-pressed', String(active)); }); }
function disposeModel() { if (!model)
    return; scene.remove(model); mixer?.stopAllAction(); if (mixer)
    mixer.uncacheRoot(model); }
function morphs(blink = 0) { model?.traverse(o => { if (!(o instanceof THREE.Mesh) || !o.morphTargetDictionary || !o.morphTargetInfluences)
    return; for (const [name, i] of Object.entries(o.morphTargetDictionary))
    o.morphTargetInfluences[i] = name === 'Blink' ? blink : name === state.expression ? state.strength : 0; }); }
function applyPose(name: string) { if (!mixer)
    return; state.pose = name; setActive('[data-pose]', 'pose', name); mixer.stopAllAction(); const clip = animations.find(c => c.name === name); if (!clip) {
    console.warn('Missing clip', name);
    return;
} currentAction = mixer.clipAction(clip); currentAction.reset().play(); currentAction.setLoop(THREE.LoopRepeat, Infinity); currentAction.paused = true; clipTime = 0; mixer.update(0); model?.updateMatrixWorld(true); $('#timeline-wrap').hidden = !state.playing; setCamera(state.camera); }
function setPlaying(on: boolean) { state.playing = on; $('#play').setAttribute('aria-pressed', String(on)); $('#play-icon').textContent = on ? 'Ⅱ' : '▷'; $('#play-label').textContent = on ? 'Pause movement' : 'Bring to life'; if (on && state.pose !== 'Swing')
    applyPose('Idle');
else if (!on && state.pose === 'Idle')
    applyPose(characterInfo ? 'Stand' : 'Neutral'); $('#timeline-wrap').hidden = !on; }
async function loadLOD(lod: number) { const version = ++loadVersion; const previousLOD = state.lod; const loading = $('#loading'); loading.hidden = false; try {
    let gltf = cache.get(lod);
    if (!gltf) {
        gltf = await loader.loadAsync(manifest.lods[lod].url);
        cache.set(lod, gltf);
    }
    if (version !== loadVersion)
        return;
    const oldPose = state.pose;
    disposeModel();
    model = gltf.scene;
    scene.add(model);
    animations = gltf.animations;
    mixer = new THREE.AnimationMixer(model);
    model.traverse(o => { if (o instanceof THREE.Mesh) {
        o.castShadow = true;
        o.receiveShadow = false;
        const mats = Array.isArray(o.material) ? o.material : [o.material];
        for (const m of mats) {
            if (m instanceof THREE.MeshStandardMaterial) {
                m.wireframe = state.wireframe;
                m.envMapIntensity = .55;
            }
        }
    } });
    state.lod = lod;
    applyPose(oldPose);
    morphs();
    $('#triangles').textContent = manifest.lods[lod].triangles.toLocaleString();
    state.ready = true;
    loading.hidden = true;
    document.body.dataset.ready = 'true';
}
catch (e) {
    console.error(e);
    $<HTMLSelectElement>('#lod').value = String(previousLOD);
    loading.innerHTML = '<span class="error">The character could not load.<br>Check the local server and refresh to retry.</span>';
} }
function setCamera(name: string) {
    state.camera = name;
    $('.stage').classList.toggle('detail-view', ['face','hands','feet','belly','shoulders'].includes(name));
    $<HTMLSelectElement>('#detail-camera').value = ['face','hands','feet','belly','shoulders'].includes(name) ? name : 'portrait';
    setActive('[data-camera]', 'camera', name);
    const fullTarget = new THREE.Vector3(.15, 1.29, 0);
    const views: Record<string, {
        p: number[];
        target?: number[];
    }> = { portrait: { p: [2.25, 2.3, 6.7] }, front: { p: [.15, 1.65, 7.15] }, side: { p: [7, 1.8, .15] }, back: { p: [-.15, 1.85, -7] }, face: { p: [.45, 2.14, 2.05], target: [0, 2.10, .0] }, hands: { p: [.91,.61,1.13], target: [.719,.49,.065] }, feet: { p: [.53,.40,1.14], target: [.24,.13,.08] }, belly: { p: [.10,1.44,1.70], target: [0,1.41,.06] }, shoulders: { p: [.45,1.81,2.7], target: [0,1.56,0] } };
    const view = views[name] || views.portrait;
    camera.position.fromArray(view.p);
    controls.target.copy(view.target ? new THREE.Vector3().fromArray(view.target) : fullTarget);
    const detail = manifest?.detailCameras?.[name];
    if (detail) {
        controls.target.fromArray(detail.target);
        camera.position.copy(controls.target).add(new THREE.Vector3().fromArray(detail.offset));
    }
    const posed = state.pose !== 'Neutral' && state.pose !== 'Idle';
    if (model && (posed || characterInfo)) {
        model.updateMatrixWorld(true);
        model.traverse(o => { if (o instanceof THREE.SkinnedMesh)
            o.computeBoundingBox(); });
        if (name === 'shoulders' && posed) {
            const chest = model.getObjectByName('chest');
            if (chest) chest.getWorldPosition(controls.target);
            controls.target.y += (state.pose === 'TailHang' ? -.08 : .08) * (characterInfo?.height || 1);
            camera.position.copy(controls.target).add(detail ? new THREE.Vector3().fromArray(detail.offset) : new THREE.Vector3(.45,.25,2.7));
        }
        else if (name === 'face' && posed) {
            const head = model.getObjectByName('head');
            if (head) {
                head.getWorldPosition(controls.target);
                controls.target.y += .18 * (character === 'baby' ? .9 : characterInfo?.height || 1);
                camera.position.copy(controls.target).add(detail ? new THREE.Vector3().fromArray(detail.offset) : new THREE.Vector3(.45, .06, 2.05));
            }
        }
        else if (!['face','hands','feet','belly','shoulders'].includes(name)) {
            const bounds = new THREE.Box3().setFromObject(model);
            const size = bounds.getSize(new THREE.Vector3());
            bounds.getCenter(controls.target);
            const direction = new THREE.Vector3().fromArray(view.p).sub(fullTarget).normalize();
            const distance = Math.max(size.y, size.x / Math.max(.5, camera.aspect)) / (2 * Math.tan(THREE.MathUtils.degToRad(camera.fov * .5))) * 1.24;
            camera.position.copy(controls.target).addScaledVector(direction, distance);
        }
    }
    controls.update();
    resize();
}
function resize() { const w = mount.clientWidth, h = mount.clientHeight; renderer.setSize(w, h, false); camera.aspect = w / h; const shift = w > 900 && !['face','hands','feet','belly','shoulders'].includes(state.camera) ? -w * .095 : 0; camera.setViewOffset(w, h, shift, 0, w, h); camera.updateProjectionMatrix(); }
new ResizeObserver(resize).observe(mount);
function lighting(name: string) { state.light = name; setActive('[data-light]', 'light', name); const tropical = name === 'canopy'; $('#lighting-caption').textContent = tropical ? 'CANOPY SUN' : 'STUDIO LIGHT'; sun.color.set(tropical ? '#ffe0a0' : '#fff2d9'); sun.intensity = tropical ? 3.3 : 2.25; fill.color.set(tropical ? '#a8e2e3' : '#d4e2ff'); fill.intensity = tropical ? .9 : 1.1; rim.intensity = tropical ? 3 : 2; hemi.intensity = tropical ? .75 : 1; scene.background = new THREE.Color(tropical ? '#dce3cc' : '#e8e5d7'); (scene.fog as THREE.Fog).color.copy(scene.background); (floor.material as THREE.MeshStandardMaterial).color.set(tropical ? '#cbd4b8' : '#dcdccb'); }
document.querySelectorAll<HTMLButtonElement>('[data-pose]').forEach(b => b.addEventListener('click', () => { setPlaying(false); applyPose(b.dataset.pose!); if (b.dataset.pose === 'Swing') {
    state.playing = true;
    $('#play').setAttribute('aria-pressed', 'true');
    $('#play-icon').textContent = 'Ⅱ';
    $('#play-label').textContent = 'Pause movement';
    $('#timeline-wrap').hidden = false;
} }));
document.querySelectorAll<HTMLButtonElement>('[data-camera]').forEach(b => b.addEventListener('click', () => setCamera(b.dataset.camera!)));
document.querySelectorAll<HTMLButtonElement>('[data-light]').forEach(b => b.addEventListener('click', () => lighting(b.dataset.light!)));
document.querySelectorAll<HTMLButtonElement>('[data-expression]').forEach(b => b.addEventListener('click', () => { state.expression = b.dataset.expression!; setActive('[data-expression]', 'expression', state.expression); morphs(); }));
$('#play').addEventListener('click', () => setPlaying(!state.playing));
$<HTMLInputElement>('#auto-orbit').addEventListener('change', e => controls.autoRotate = (e.target as HTMLInputElement).checked);
$<HTMLInputElement>('#wireframe').addEventListener('change', e => { state.wireframe = (e.target as HTMLInputElement).checked; model?.traverse(o => { if (o instanceof THREE.Mesh) {
    for (const m of Array.isArray(o.material) ? o.material : [o.material])
        if (m instanceof THREE.MeshStandardMaterial)
            m.wireframe = state.wireframe;
} }); });
$<HTMLSelectElement>('#lod').addEventListener('change', e => loadLOD(Number((e.target as HTMLSelectElement).value)));
$<HTMLInputElement>('#expression-strength').addEventListener('input', e => { state.strength = Number((e.target as HTMLInputElement).value); $('#expression-value').textContent = Math.round(state.strength * 100) + '%'; morphs(); });
$<HTMLSelectElement>('#revision-select').addEventListener('change', e => {
    const url = new URL(location.href);
    url.searchParams.set('revision', (e.target as HTMLSelectElement).value);
    url.searchParams.set('pose', state.pose);
    url.searchParams.set('view', state.camera);
    location.href = url.toString();
});
$<HTMLSelectElement>('#character-select').addEventListener('change', e => {
    const url = new URL(location.href);
    const next = (e.target as HTMLSelectElement).value;
    url.searchParams.set('character', next);
    url.searchParams.delete('revision');
    url.searchParams.set('pose', state.pose === 'Stand' || state.pose === 'Neutral' ? next === 'default' ? 'Neutral' : 'Stand' : state.pose);
    url.searchParams.set('view', state.camera);
    location.href = url.toString();
});
$<HTMLSelectElement>('#detail-camera').addEventListener('change', e => {
    const view = (e.target as HTMLSelectElement).value;
    setPlaying(false); if (view !== 'shoulders') applyPose('Neutral'); setCamera(view);
});
$('#reset-camera').addEventListener('click', () => setCamera('portrait'));
$<HTMLInputElement>('#timeline').addEventListener('input', e => { if (currentAction) {
    clipTime = Number((e.target as HTMLInputElement).value) * currentAction.getClip().duration;
    currentAction.time = clipTime;
    mixer?.update(0);
} });
$('#capture').addEventListener('click', () => { renderer.render(scene, camera); const a = document.createElement('a'); a.download = `canopy-${character}-${revision}-${state.pose.toLowerCase()}-${state.camera}.png`; a.href = renderer.domElement.toDataURL('image/png'); a.click(); });
const dialog = $<HTMLDialogElement>('#reference-dialog');
$('#open-reference').addEventListener('click', () => dialog.showModal());
$('#close-reference').addEventListener('click', () => dialog.close());
dialog.addEventListener('click', e => { if (e.target === dialog) {
    const r = dialog.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)
        dialog.close();
} });
document.querySelectorAll<HTMLButtonElement>('[data-ref]').forEach(b => b.addEventListener('click', () => { const original = b.dataset.ref === 'original'; setActive('[data-ref]', 'ref', b.dataset.ref!); $<HTMLImageElement>('#reference-full').src = original ? '/references/concept-board.png' : '/references/hero-study-r01.png'; $('#reference-caption').textContent = original ? characterInfo ? 'Original concept board · The standing lineup defines Dark, Golden, Snow, Red-faced and Baby.' : 'Original concept board · The large action monkey at upper left is the canonical likeness target.' : 'Generated construction study · Shared hero proportions and construction guidance.'; }));
if (characterInfo) {
    $<HTMLImageElement>('.reference-image img').src = '/references/concept-board.png';
    $<HTMLImageElement>('.reference-image img').alt = 'Original concept board with the standing monkey lineup';
    $('[data-ref="original"]').click();
}
setCamera(initialCamera);
function tick(now: number) {
    const dt = Math.min((now - previousTime) / 1000, .06);
    previousTime = now;
    if (state.playing && currentAction) {
        clipTime = (clipTime + dt) % currentAction.getClip().duration;
        currentAction.time = clipTime;
        mixer?.update(0);
        $<HTMLInputElement>('#timeline').value = String(clipTime / currentAction.getClip().duration);
        $('#time-label').textContent = clipTime.toFixed(2) + 's';
    }
    const blink = state.playing ? Math.pow(Math.max(0, Math.cos(now * .0015)), 64) : 0;
    morphs(blink);
    controls.update();
    updateGrip();
    renderer.render(scene, camera);
    frameCount++;
    if (now - fpsTime > 800) {
        fps = frameCount * 1000 / (now - fpsTime);
        $('#fps').textContent = String(Math.round(fps));
        $('#drawcalls').textContent = String(renderer.info.render.calls);
        frameCount = 0;
        fpsTime = now;
    }
    requestAnimationFrame(tick);
}
requestAnimationFrame(tick);
fetch(`/assets/${assetPrefix}.json`).then(r => { if (!r.ok)
    throw Error('Manifest missing'); return r.json(); }).then((m: Manifest) => { manifest = m; return loadLOD(0); }).catch(e => { console.error(e); $('#loading').innerHTML = '<span class="error">The asset manifest is unavailable.<br>Run npm run art:build and reload.</span>'; });
// Read-only inspection interface for repeatable browser QA; movement stays in the future C++ core.
Object.defineProperty(window, 'canopyStudio', { value: { get state() { return { ...state }; }, get clips() { return animations.map(a => a.name); }, get metrics() { return { fps, drawCalls: renderer.info.render.calls, triangles: renderer.info.render.triangles }; }, get landmarks() { const result: Record<string, number[]> = {}; for (const name of ['head', 'pelvis', 'hand.L', 'tail.17']) {
            const bone = model?.getObjectByName(THREE.PropertyBinding.sanitizeNodeName(name));
            if (bone)
                result[name] = bone.getWorldPosition(new THREE.Vector3()).toArray();
        } return result; }, get bounds() { return model ? new THREE.Box3().setFromObject(model).getSize(new THREE.Vector3()).toArray() : []; } } });
